// src/router/index.js
import { createRouter, createWebHistory } from 'vue-router';
import Home from '../views/Home.vue';
import ImageEdit from '../views/ImageEdit.vue';
import ExampleSquare from '../views/ExampleSquare.vue';
import Tools from '../views/Tools.vue';
import MyPage from '../views/MyPage.vue';
import MyWorks from '../views/MyWorks.vue';
import VipPage from '../views/VipPage.vue';
import AgentCenter from '../views/AgentCenter.vue';
import GroupBuyHome from '../views/groupbuy/GroupBuyHome.vue';
import GroupBuyDetail from '../views/groupbuy/GroupBuyDetail.vue';
import MyGroupBuys from '../views/groupbuy/MyGroupBuys.vue';
import { wechatSilentLogin, isWechat, redirectToWechatAuth, getUrlParam } from '@/utils/wechatAuth';

const routes = [
  {
   path: '/',
   name: 'Home',
   component: Home,
    meta: { requiresAuth: true }
  },
  {
  path: '/image-edit',
  name: 'ImageEdit',
  component: ImageEdit,
    meta: { requiresAuth: true }
  },
  {
  path: '/example-square',
  name: 'ExampleSquare',
  component: ExampleSquare,
    meta: { requiresAuth: true }
  },
  {
    path: '/tools',
    redirect: '/example-square'
  },
  {
  path: '/my',
  name: 'MyPage',
  component: MyPage,
    meta: { requiresAuth: true }
  },
  {
  path: '/my-works',
  name: 'MyWorks',
  component: MyWorks,
    meta: { requiresAuth: true }
  },
  {
  path: '/vip',
  name: 'VipPage',
  component: VipPage,
    meta: { requiresAuth: true }
  },
  {
    path: '/agent-center',
    name: 'AgentCenter',
    component: AgentCenter,
    meta: { requiresAuth: true }
  },
  {
    path: '/group-buy',
    name: 'GroupBuyHome',
    component: GroupBuyHome,
    meta: { requiresAuth: false }
  },
  {
    path: '/group-buy/:id',
    name: 'GroupBuyDetail',
    component: GroupBuyDetail,
    meta: { requiresAuth: false }
  },
  {
    path: '/my-group-buys',
    name: 'MyGroupBuys',
    component: MyGroupBuys,
    meta: { requiresAuth: false }
  },
];

const router= createRouter({
  history: createWebHistory(),
  routes,
});

// 全局前置守卫
router.beforeEach(async (to, from, next) => {
  // 检查 URL 中是否有 agent 参数，如果有则保存到 localStorage
  const agentId = getUrlParam('agent');
  if (agentId) {
    localStorage.setItem('agentId', agentId);
  }

  // 不需要认证的路由
  if (!to.meta.requiresAuth) {
    next();
    return;
  }

  // 检查用户是否已登录
  const userStr = localStorage.getItem('user');
  if (userStr) {
    next();
    return;
  }

  const appId = process.env.VUE_APP_WECHAT_APPID;
  const user = await wechatSilentLogin(appId, agentId);
  if (user) {
    localStorage.setItem('user', JSON.stringify(user));
    next();
  } else {
    redirectToWechatAuth(appId, window.location.href, agentId);
    next(false);
  }
});

export default router;
